// @flow
import { delay } from 'redux-saga';
import { put, takeEvery, call, select } from 'redux-saga/effects';
import {
  deleteAnswer,
  deleteAnswerSync,
  editAnswer,
  editAnswerSync,
} from './answerEditingActions';
import { type ActionType } from 'redux-actions';
import { deleteUgc, updateResponse } from 'ducks/coreDataApi';
import { updateUgc, removeUgc } from 'ducks/coreDataActions';
import { boundedDelay, selectToken } from 'ducks/SagaUtils';
import { UGC as Ugc } from 'models';

function* deleteAnswerSaga(action: ActionType<deleteAnswer>) {
  const {
    payload: { ugc_id, target, parent_ugc_id },
  } = action;
  const token = yield select(selectToken);
  const startTs = Date.now();
  let actionToPut;

  try {
    yield call(deleteUgc, token, ugc_id);
    actionToPut = deleteAnswerSync(action.payload);
    if (target === 'Question') {
      yield put(
        updateUgc(ugc => {
          return ugc.update('ugc_related_content', l =>
            l.filter(ugc => ugc.ugc_id !== ugc_id)
          );
        }, parent_ugc_id)
      );
    } else if (target === 'Answer') {
      yield put(removeUgc(ugc_id));
    }
  } catch (err) {
    actionToPut = deleteAnswerSync(err, action.payload);
  } finally {
    yield call(delay, boundedDelay(startTs));
    yield put(actionToPut);
  }
}

function* editAnswerSaga(action: ActionType<typeof editAnswer>) {
  const token = yield select(selectToken);
  const startTs = Date.now();
  const { ugc_id, parent_ugc_id, target } = action.payload;

  try {
    const response = yield call(updateResponse, token, action.payload);
    const updatedUgc = Ugc.createWithData({ ugc: response });
    yield call(delay, boundedDelay(startTs));
    yield put(editAnswerSync(updatedUgc, action.payload));

    if (target === 'Question') {
      yield put(
        updateUgc(ugc => {
          const idx = ugc.ugc_related_content.findIndex(
            ugc => ugc.ugc_id === ugc_id
          );

          return ugc.setIn(['ugc_related_content', idx], updatedUgc);
        }, parent_ugc_id)
      );
    } else if (target === 'Answer') {
      function updateAnswerProperties(ugc) {
        // the response payload  does not include the question,
        // so we need to add it to the new object
        const existingQuestion = ugc.getQuestion();
        const {
          answer,
          updated_date,
          author,
          location,
          ugc_related_content,
        } = updatedUgc;

        return ugc.merge({
          author,
          location,
          answer,
          updated_date,
          ugc_related_content: ugc_related_content.push(existingQuestion),
        });
      }

      yield put(updateUgc(updateAnswerProperties, ugc_id));
    }
  } catch (err) {
    yield call(delay, boundedDelay(startTs));
    yield put(editAnswerSync(err, action.payload));
  }
}

export function* saga(): Generator<*, *, *> {
  yield takeEvery(deleteAnswer, deleteAnswerSaga);
  yield takeEvery(editAnswer, editAnswerSaga);
}



// WEBPACK FOOTER //
// ./src/containers/answer-editing/answerEditingSaga.js